@if (isGrouped) {
  <div class="claim-popup grouped">
    <div class="popup-header-row">
      <div class="title">{{ groupCount }} {{ titlePlural }}</div>
      @if (date) {
        <div class="date-chip">
          <span class="date-chip-text">{{ date | date: 'MMM d' }}</span>
        </div>
      }
    </div>
    <div class="claim-list">
      @for (claim of claims; track claim.id) {
        <div class="claim-row" (click)="onSelectClaim(claim)">
          <div class="row-header">
            <div class="claim-id">{{ numberFor(claim) }}</div>
            <div
              class="chip"
              [style.background]="statusFor(claim).bg"
              [style.color]="statusFor(claim).fg">
              {{ statusFor(claim).label }}
            </div>
          </div>
          @if (titleFor(claim)) {
            <div class="claim-title-sm">{{ titleFor(claim) }}</div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="claim-popup">
    <div class="popup-header-row">
      <div class="title">{{ titleSingular }}</div>
      @if (date) {
        <div class="date-chip">
          <span class="date-chip-text">{{ date | date: 'MMM d' }}</span>
        </div>
      }
    </div>

    @if (claimNumber) {
      <div class="claim-number">{{ claimNumber }}</div>
    }

    @if (title) {
      <div class="claim-title">{{ title }}</div>
    }

    @if (description) {
      <div class="claim-description">{{ description }}</div>
    }

    <div class="chips-row">
      <div
        class="chip"
        [style.background]="status.bg"
        [style.color]="status.fg">
        {{ status.label }}
      </div>
      @if (severity) {
        <div
          class="chip"
          [style.background]="severity.bg"
          [style.color]="severity.fg">
          {{ severity.label }}
        </div>
      }
    </div>

    @if (thumbs.length) {
      <div class="thumbs-row">
        @for (pic of thumbs; track pic.id) {
          <div class="thumb">
            <img [src]="pic.thumb_url || pic.original_url" alt="" />
          </div>
        }
      </div>
    }

    <div class="see-more" (click)="onSeeMore()">{{ isPunchlist ? 'Open item' : 'See more' }}</div>
  </div>
}
